import { TextBox, TextBoxHandle } from '@progress/kendo-react-inputs';
import React from 'react';
import { UnitFormatter } from '../../formatters';
import { parseLat, parseLng } from '../../common/position-parser';

interface LatLngInputProps {
    type: 'lat' | 'lng';
    disabled?: boolean;
    value: number | null;
    onChange: (value: number | null) => void;
}

const LatLngInput = (props: LatLngInputProps) => {
    const ref = React.createRef<TextBoxHandle>();
    const [valid, setValid] = React.useState(true);

    React.useEffect(() => {
        ref.current!.element!.value = formatLatLng(props.value, props.type);
    }, [props.value, props.type]);

    const handleBlur = () => {
        const value = ref.current!.element!.value;
        const num = props.type === 'lat' ? parseLat(value) : parseLng(value);
        if (num !== null) {
            if (num === props.value) {
                ref.current!.element!.value = formatLatLng(num, props.type);
            }
            props.onChange(num);
            setValid(true);
        } else {
            setValid(false);
        }
    };

    const handleOnKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleBlur();
        }
    };

    return <TextBox valid={valid} disabled={props.disabled} onBlur={handleBlur} onKeyDown={handleOnKey} ref={ref} />;
};

function formatLatLng(value: number | null, type: 'lat' | 'lng'): string {
    return value !== null ? (type === 'lat' ? UnitFormatter.formatLatValue(value) : UnitFormatter.formatLngValue(value)) : '';
}

export default LatLngInput;
